import React from 'react';
import { Row, Col } from 'reactstrap';
import { useContext } from 'react';
import { AgentCtx } from '../../../contexts/AgentCtx';
import QueueList from '../../AgentIndicators/components/QueueList';
import ChatsAnswers from '../../AgentIndicators/components/ChatsAnswers';
import TMACardChat from '../../AgentIndicators/components/TMACardChat';
import TMFirstMessage from '../../AgentIndicators/components/TMFirstMessage';
import AgentConversationInfo from '../../AgentIndicators/components/AgentConversationInfo';

const ChatTab = ({ dashboardChatIndividually }) => {
  const { queues } = useContext(AgentCtx);

  return (
    <>
      <Row xl="12">
        <Col xl="6">
          <Col xl="6">
            <ChatsAnswers data={dashboardChatIndividually.totalChatsAnswers} />
          </Col>
          <Col xl="6">
            <TMACardChat data={dashboardChatIndividually.averageServiceTime} />
          </Col>
          <Col xl="6">
            <TMFirstMessage
              data={dashboardChatIndividually.averageFirstResponseTime}
            />
          </Col>
        </Col>
        <Col xl="6">
          <QueueList
            data={
              queues.map(({ id, name }) => ({
                id,
                name
              })) || []
            }
          />
        </Col>
      </Row>
      <Row>
        <Col xl="12">
          <AgentConversationInfo />
        </Col>
      </Row>
    </>
  );
};

export default ChatTab;
